import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  background: #f0f2f5;
  min-height: calc(100vh - 64px);
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
